// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"577":"bugsnag","645":"glide-bundle"}[chunkId] || chunkId) + "-" + {"247":"93cf2363440bf6ed8588","577":"15e5130561a3bfabac2d","645":"ccff90c5c63af608b494"}[chunkId] + ".chunk.js";
};